// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PC9E","index":"styles_index__31zm0"};